// DropBuyUrlRedirect.js
import React from 'react';
import { useLazyUrlRedirectQuery } from '../../../services/dropBuyApi';
import { copyToClipBoard } from "../../../utils";
import { IconButton } from "@mui/material";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

export function DropBuyUrlRedirectCopyIcon({ params }) {
  const [urlRedirect] = useLazyUrlRedirectQuery();

  const handleClick = async () => {
    try {
      const data = await urlRedirect({ i: params.row.jobID, t: params.row.eventLink }).unwrap();
      console.log("log saved for url redirect url: " + data?.url);
    } catch (error) {
      console.log(error);
      throw error;
    }
    await copyToClipBoard(params.row.eventLink || "-- ERROR --");
  };

  return (
    <IconButton
      sx={{ margin: "0 0 0 0.25em" }}
      color="primary"
      onClick={handleClick}
    >
      <ContentCopyOutlinedIcon fontSize="small" />
    </IconButton>
  );
}

export function DropBuyUrlRedirect({params}){
  const [urlRedirect] = useLazyUrlRedirectQuery();

  const handleClick = async () => {
    try {
      const data = await urlRedirect({ i: params.row.jobID, t: params.row.eventLink }).unwrap();
      console.log("log saved for url redirect url: " + data?.url);
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const handleAuxClick = (e) => {
    if (e.button === 1) {
      handleClick();
    }
  };

  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  return (
    <a
      href={params.row.eventLink}
      onClick={handleClick}
      onContextMenu={handleContextMenu}
      onAuxClick={handleAuxClick}
      target="_blank" rel="noreferrer"
      rel="noopener noreferrer"
    >
      {params.row.eventName}
    </a>
  );
}